import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    GamesColumn,
    GamesPageHeaderRow,
    GamesPageTitle,
    LoadingProviderChip,
    LoadingProvidersList,
    LoadingProviderSpinner,
} from 'src/domains/casino/components/games/GamesPage.style';
import { CasinoGamesList } from 'src/domains/casino/components/games/CasinoGamesList';
import { SearchAndFiltersGamesList } from 'src/components/CmsCasinoManagement/SearchAndFilters/SearchAndFiltersGamesList';
import { GamesPageState } from 'src/domains/casino/components/games/GamesPage.state';
import { CollectionType } from 'src/domains/casino/models/models';

interface CasinoGamesPageType {
    collection: CollectionType;
}

export const CasinoGamesPage = observer('CasinoGamesPage', (props: CasinoGamesPageType) => {
    const { configState, appCasinoState } = useAppStateContext();
    const [state] = React.useState(() => new GamesPageState(appCasinoState, configState, props.collection));

    return (
        <GamesColumn>
            <GamesPageHeaderRow>
                <GamesPageTitle>All Games</GamesPageTitle>
                {state.loadingProviders.length > 0 ? (
                    <LoadingProvidersList data-test='games-loading-providers'>
                        {state.loadingProviders.map((provider) => (
                            <LoadingProviderChip
                                data-test={`games-loading-provider-${provider.provider}`}
                                key={provider.provider}
                            >
                                <LoadingProviderSpinner />
                                {provider.providerName}
                            </LoadingProviderChip>
                        ))}
                    </LoadingProvidersList>
                ) : null}
            </GamesPageHeaderRow>
            <SearchAndFiltersGamesList gamesPageState={state} />
            <CasinoGamesList gamesPageState={state} />
        </GamesColumn>
    );
});
